import { render, staticRenderFns } from "./DialogBackHandler.vue?vue&type=template&id=183ce37a&scoped=true"
import script from "./DialogBackHandler.vue?vue&type=script&lang=js"
export * from "./DialogBackHandler.vue?vue&type=script&lang=js"
import style0 from "./DialogBackHandler.vue?vue&type=style&index=0&id=183ce37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183ce37a",
  null
  
)

export default component.exports